import styled, { css } from 'styled-components';
import { mobile_xl, mobile_xs } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter, HideScrollbar } from '../../../global/commonStyle';

const TableData = styled.div`
  display: flex;
  justify-content: space-between;
  padding: var(--space-12) var(--space-16);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border: none;
  }
`;

const UserDetails = styled.div`
  max-width: 762px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
`;

const Username = styled.div`
  width: 100px;
  height: 14px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const UserDescription = styled.div`
  width: 250px;
  height: 10px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
  ${mobile_xl(css`
    width: 160px;
  `)}
  ${mobile_xs(css`
    width: 120px;
  `)}
`;

const UserTime = styled.div`
  width: 38px;
  height: 15px;
  background-color: var(--background-muted);
  border-radius: var(--border-radius-full);
`;

const StopIcon = styled.div`
  width: 32px;
  height: 32px;
`;

const PrivateData = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  .loading-icon {
    path {
      fill: var(--background-muted);
    }
    path.fill1 {
      fill: var(--background-primary);
    }
  }
`;
const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }
  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
  ${mobile_xl(css`
    margin-top: var(--space-8);
  `)}
`;
const Circle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
`;
const Div = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;
const Line = styled.div`
  border-right: 0.5px solid var(--border-primary);
  width: 1px;
  height: 28px;
`;
const Header = styled.div`
  max-width: 1021px;
  width: 100%;
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  background: var(--background-primary);
  ${AlignCenter}
`;
const BottomDiv = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  background: var(--background-primary);
`;
const SvgDiv = styled.div`
  ${FlexCenter}
  svg {
    fill: none;
  }
`;
const LeftBlock = styled.div`
  padding-inline: var(--space-6);
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  margin-top: -1px;
  cursor: pointer;
  ${mobile_xl(css`
    border-right: 0;
  `)}
`;
const RightBlock = styled.div`
  padding-inline: var(--space-6);
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  cursor: pointer;
`;
const MiddleLine = styled.div`
  max-width: 956px;
  display: flex;
  width: 100%;
  border-inline: 0.5px solid var(--border-primary);
  ${HideScrollbar}
  .box {
    max-width: 138px;
    width: 100%;
    border-right: 0.5px solid var(--border-primary);
    :last-child {
      border-right: none;
    }
    ${mobile_xl(css`
      max-width: 150px;
    `)}
  }
  .last-box {
    background: var(--background-secondary);
    opacity: 0.8;
  }
`;
const SliderBox = styled.div`
  padding: var(--space-16);
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;
const DateTitle = styled.div`
  width: 70px;
  height: 13px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    padding-block: var(--space-1);
  `)}
`;

const TimeTitle = styled.div`
  width: 40px;
  height: 9px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
  ${mobile_xl(css`
    padding-block: var(--space-1);
  `)}
`;

export {
  TableData,
  UserDetails,
  Username,
  UserDescription,
  UserTime,
  StopIcon,
  PrivateData,
  MainContent,
  Circle,
  Div,
  Line,
  Header,
  BottomDiv,
  SvgDiv,
  LeftBlock,
  RightBlock,
  MiddleLine,
  SliderBox,
  DateTitle,
  TimeTitle
};
